import {useOffer} from "../../../hooks/useOffers";
import StarIcon from "../../../images/icons/starIcon";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {userRoleList} from "../../../utils/constants";
import OfferInfoCard from "../../components/offer/infoCard";
import AttachedFiles from "../../components/offer/offerFiles";
import ImageComponent from "../../components/shared/ImageComponent";
import Loader from "../../components/shared/Loader";
import NoImage from "../../../images/profileImage.png";
import {useMe} from "../../../hooks/useGetUser";
import {Link} from "react-router-dom";
import {useEffect} from "react";
import QueryErrorState from "../../components/shared/QueryErrorState";

const OfferPage = () => {
  const {data, isLoading, isError, error, refetch} = useOffer();
  const {
    data: user,
    isLoading: isMeLoading,
    isError: isMeError,
    error: meError,
    refetch: refetchMe,
  } = useMe();
  useEffect(() => {}, []);
  if (isLoading || isMeLoading) return <Loader />;
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  if (isMeError) {
    return <QueryErrorState error={meError} onRetry={refetchMe} />;
  }

  return (
    <>
      <div className="w-full flex flex-col lg:grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit   px-4 lg:!px-0  lg:block ">
          <Link
            to={
              user?.selectedRole === userRoleList.CLIENT
                ? "/mon-profil"
                : `/client/${data?.Client?.id}`
            }
            className="flex gap-3 lg:gap-0 lg:flex-col rounded-2xl bg-white justify-start items-center  p-4"
          >
            <div className="relative lg:mt-4 ">
              {!!data?.Client?.User?.avgRating && (
                <div className="bg-[#FFC107] w-[38px] flex justify-center gap-[2px] items-center  p-[1px] text-white leading-3 text-[10px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
                  {Number(data?.Client?.User?.avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-2 h-2" />
                </div>
              )}
              <ImageComponent
                src={buildImageUrl(data?.Client?.User?.imageUri)}
                alt=""
                className=" w-14  lg:w-[104px] aspect-square rounded-full object-cover ring-4 ring-white"
                fallback={
                  <img
                    src={NoImage}
                    alt=""
                    className=" w-14  lg:w-[104px] aspect-square rounded-full object-cover"
                    width="130"
                  />
                }
              />
            </div>
            <div className="flex flex-col rounded-2xl bg-white gap-1 justify-start items-start lg:items-center">
              <div className="lg:text-center leading-3 text-[#19295C] font-semibold capitalize lg:mt-3">
                {`${data?.Client?.User.lastName}  ${data?.Client?.User.firstName}`}
              </div>
              <div className="lg:text-center text-primary font-normal text-sm">
                Client
              </div>
            </div>
            <Link
              to={
                user?.selectedRole === userRoleList.CLIENT
                  ? "/mon-profil#avis"
                  : `/client/${data?.Client?.id}#avis`
              }
              title="évaluations"
              className="text-right lg:text-center flex-grow text-nowrap lg:flex-grow-0 text-xs font-normal lg:mt-3   underline text-[#7E7E7E] "
            >
              {data?.Client?.User?.reviews?.length ?? 0}{" "}
              <span className="sm:hidden">éval(s)</span>
              <span className="hidden sm:inline">évaluation(s)</span>
            </Link>
          </Link>
        </div>
        <div className="w-full col-span-2 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          <OfferInfoCard className={""} offer={data} />
        </div>

        <div className="w-full px-4 lg:!px-0  lg:flex flex-col gap-4 ">
          <AttachedFiles files={data?.FileUploads} />
        </div>
      </div>
    </>
  );
};

export default OfferPage;
